import {NewResellerModel} from 'server/models/reseller.js'

export default () => {
    const reseller = JSON.parse(JSON.stringify(NewResellerModel.parse({})))

    // Only for new resellers, existing accounts keep allowing to start a non-optimized route
    reseller.settings.routeNotOptimizedWarning = 'notallowed'

    // Only for new resellers, existing accounts don't let the messenger change a completed address (#701)
    reseller.settings.messengerEditCompletedAddress = 'last'

    return reseller
}
